import { render, staticRenderFns } from "./JsonView.vue?vue&type=template&id=5ef612ae&"
import script from "./JsonView.vue?vue&type=script&lang=js&"
export * from "./JsonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports